











import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class StorybookButton extends Vue {
  get isEmptyData() {
    return _.isEmpty(this.propData)
  }

  get propData() {
    return this.$slots.default[0].componentOptions.propsData
  }
}
